import {Component, OnInit, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AbwDatasourceColumn, Model_WorkflowComponent, AbwDatasourceFilter } from 'src/app/app.models';
import { MatTableDataSource } from '@angular/material/table';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
    selector: 'app-input-grid-columns-datasource-mapping-dialog',
    templateUrl: './input-grid-columns-datasource-mapping-dialog.component.html',
    styleUrls: ['./input-grid-columns-datasource-mapping-dialog.component.scss']
})
export class InputGridColumnsDatasourceMappingDialogComponent implements OnInit {
    displayedColumns = ['PRIMARY_KEY_DATASOURCE', 'GRID_COLUMN', 'DATASOURCE_COLUMN'];
    dataSource = new MatTableDataSource<FormGroup>();

    datasourceColumns: AbwDatasourceColumn[];
    gridColumns: Model_WorkflowComponent[];
    PRIMARY_KEY_DATASOURCE = 0;

    constructor(
        public dialogRef: MatDialogRef<InputGridColumnsDatasourceMappingDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { gridColumns: Model_WorkflowComponent[], datasourceColumns: AbwDatasourceColumn[], columnsMapping: { PRIMARY_KEY: boolean, GRID_COLUMN: string, DATASOURCE_COLUMN: any }[] },
    ) {
        this.gridColumns = data.gridColumns;
        this.datasourceColumns = data.datasourceColumns;
        this.dataSource.data = this.gridColumns.map(c => {
            const columnMapping = data.columnsMapping.find(m => m.GRID_COLUMN == c.ID);
            return new FormGroup({ PRIMARY_KEY: new FormControl(!!columnMapping ? columnMapping.PRIMARY_KEY : false), GRID_COLUMN: new FormControl(c.ID), DATASOURCE_COLUMN: new FormControl(!!columnMapping ? columnMapping.DATASOURCE_COLUMN : null) });
        });
    } 
    
    ngOnInit() {
    }

    dismiss(): void {
        this.dialogRef.close();
    }

    onSubmit() {
        const rows = this.dataSource.data;
        const value = rows.map(formGroup => formGroup.value);
        this.dialogRef.close(value);
    }

	onPrimaryKeyChanged(rowChangeEvent?: { index: number, value: string }) {
        if (!!rowChangeEvent) {
            this.dataSource.data[rowChangeEvent.index].controls.DEFAULT_VALUE.patchValue(rowChangeEvent.value);
        }
        const rows = this.dataSource.data;
        rows.forEach((row, index, rowsArr) => {
            rowsArr[index].controls.PRIMARY_KEY.patchValue(this.PRIMARY_KEY_DATASOURCE == index);
        })
	}
}